export default __webpack_public_path__ + "e450165ac94adc67e354b949875c526b.png";